/**
 * Dismisses the search sheet when the reader clicks away from it.
 *
 * Every drawer in this theme closes when the dimmed page behind it is clicked —
 * the cart, the mobile menu and the rest each attach their own listener to
 * .PageOverlay. The search sheet raises that same overlay and is the one thing
 * that never listened to it, so the only way out was the close button.
 *
 * Asks the theme to close through its own 'search:close' event rather than
 * reaching into SearchBar, so putting the sheet away runs exactly the code the
 * close button runs: focus trap released, scroll lock lifted, overlay faded and
 * the header's z-index put back. The theme dispatches this event itself when a
 * drawer opens over the search, so this is a supported way in rather than a
 * private detail.
 */
(function () {
  'use strict';

  var search = document.querySelector('#Search');
  if (!search) return;

  /* pointerdown rather than click: a click reports where the button came up, so
     selecting text in the field and releasing past the edge of the sheet would
     read as a click outside and throw away what had been typed. */
  document.addEventListener('pointerdown', function (event) {
    if (search.getAttribute('aria-hidden') !== 'false') return;

    var target = event.target;
    if (!target || !target.closest) return;

    // The sheet itself, and the icon that opened it, are the theme's own.
    if (target.closest('#Search')) return;
    if (target.closest('[data-action="toggle-search"], [data-action="open-search"], [data-action="close-search"]')) return;

    /* Searchanise draws its suggestions outside the sheet, so a click on one is
       a click on the search wherever it happens to sit in the document. */
    if (target.closest('[class*="snize"], [id*="snize"]')) return;

    search.dispatchEvent(new CustomEvent('search:close', { bubbles: true }));
  });
})();
